module.exports = {
  paymentProccessing: 'Verarbeitung der Zahlungen gestartet.',
  paymentSuccessful: 'Zahlung als erfolgreich markiert.',
  transactionCancel: 'Storno der Transaktion gestartet.',
  reRegistration: 'Neu-Anmeldung erfolgreich',
  dataRedy: 'Ihre Daten sind bereit für',
  wallet: 'Etui: erfolgreich aktualisiert!',
  order: 'Bestellung',
  thankYuou: 'Danke für Ihren Auftrag!',
  yourOrderNuber: 'Ihre Bestellnummer ist:',
  created_successfully: 'erstellt.',
  updated_successfully: 'geändert.',
  companySettingsRefreshed: 'Firmeneinstellung erfolgreich aktualisiert!',
  catalogRefreshed: 'Katalog erfolgreich aktualisiert!',
  sendSuccess: 'Ihre Anfrage wurde gesendet. Sie erhalten in Kürze eine E-Mail!',
  addressUpdated: 'Adressdaten wurden aktualisiert',
  addedToCart: 'hinzugefügt',
  postalSet: 'PLZ gespeichert! Bitte auf Prüfen klicken um etwaige Lieferkosten zu berechnen.',
  deliveryCalculated: 'Lieferkosten erfolgreich berechnet.',
  registrationSuccessfully: 'Registrierung erfolgreich. Sie erhalten in Kürze eine E-Mail zur Aktivierung!',
  passSuccess: 'Kennwort erfolgreich gesetzt. Sie sind nun angemeldet.',
  thankYou: 'Vielen Dank für Ihre Bestellung! Bitte prüfen Sie ihr Email Postfach und den Spam Order.',
  paymentOrderOk: 'Bestellung erfolgreich bezahlt!',
  visitOk: 'Besuch erfolgreich dokumentiert.',
  rateOk: 'Vielen Dank! Ihre Meinung ist uns wichtig.',
  continueTo: 'Weiter zu',
  blacklist: 'Blacklist: Eintrag erfolgreich erstellt.',
};



// WEBPACK FOOTER //
// ./src/lang/de/success.js